import { render, staticRenderFns } from "./storeGoodsImageDrawer.vue?vue&type=template&id=12fb9008&scoped=true&"
import script from "./storeGoodsImageDrawer.vue?vue&type=script&lang=js&"
export * from "./storeGoodsImageDrawer.vue?vue&type=script&lang=js&"
import style0 from "./storeGoodsImageDrawer.vue?vue&type=style&index=0&id=12fb9008&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fb9008",
  null
  
)

export default component.exports